import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskItsmTicketTypesConfigRoute: InvariantJiraRoute = {
	exact: true,
	name: 'project-settings-servicedesk-itsm-ticket-types-config',
	path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice',
};
